import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=25bf8a04&scoped=true"
import script from "./CGU.vue?vue&type=script&lang=js"
export * from "./CGU.vue?vue&type=script&lang=js"
import style0 from "./CGU.vue?vue&type=style&index=0&id=25bf8a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf8a04",
  null
  
)

export default component.exports